import { topStories } from "@/mocks/homeData";

export default function TopStories() {
  const [lead, ...rest] = topStories;
  return (
    <section id="today" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
              <i className="ri-fire-fill" aria-hidden="true"></i>实时热搜
            </span>
            <h2 className="mt-3 text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              今日炸点
            </h2>
          </div>
          <a href="#feed" className="inline-flex items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700 whitespace-nowrap">
            查看更多盘点
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-7 grid gap-5 lg:grid-cols-[1.35fr_1fr]">
          <a
            href="#feed"
            className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100 sm:flex-row"
          >
            <div className="relative overflow-hidden sm:w-1/2">
              <img
                src={lead.img}
                alt={lead.alt}
                className="h-56 w-full object-cover transition-transform duration-500 group-hover:scale-105 sm:h-full"
              />
              <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                {lead.tag}
              </span>
            </div>
            <div className="flex flex-1 flex-col justify-center p-5 md:p-6">
              <div className="flex items-center gap-2 text-xs font-medium text-foreground-600">
                <span className="rounded bg-accent-100 px-2 py-0.5 text-accent-800">{lead.cat}</span>
                <span>{lead.date}</span>
                <span className="ml-auto flex items-center gap-1 text-primary-600">
                  <i className="ri-fire-fill" aria-hidden="true"></i>{lead.heat} 万
                </span>
              </div>
              <h3 className="mt-3 text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl">
                {lead.title}
              </h3>
              <p className="mt-2.5 hidden text-sm leading-relaxed text-foreground-700 sm:block">{lead.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
                围观详情
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
              </span>
            </div>
          </a>

          <div className="grid gap-5">
            {rest.map((s) => (
              <a
                key={s.id}
                href="#feed"
                className="group flex gap-4 overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-3 transition-shadow hover:border-primary-200"
              >
                <img
                  src={s.img}
                  alt={s.alt}
                  className="h-28 w-24 shrink-0 rounded-xl object-cover sm:h-32 sm:w-28"
                />
                <div className="flex min-w-0 flex-col justify-center">
                  <div className="flex items-center gap-2 text-xs font-medium text-foreground-600">
                    <span className="rounded bg-accent-100 px-2 py-0.5 text-accent-800">{s.cat}</span>
                    <span>{s.date}</span>
                  </div>
                  <h3 className="mt-2 line-clamp-2 text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {s.title}
                  </h3>
                  <p className="mt-1.5 flex items-center gap-1 text-xs font-medium text-primary-600">
                    <i className="ri-eye-line" aria-hidden="true"></i>{s.heat} 万人围观
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}